<template>
  <div>
    <CarouselRender v-if="isCarousel" :message="message" />
    <ImageRender v-if="isImage" :message="message" />
    <QuickReplyRender v-if="isQuickReply" :message="message" />
    <ButtonRender v-if="isButton" :message="message" />
    <p v-if="isBotText">{{message.message.message.text}}</p>
    <p v-if="isAgentText">{{message.content}}</p>
  </div>
</template>
<script>
import CarouselRender from "./CarouselRender";
import ImageRender from "./ImageRender";
import QuickReplyRender from "./QuickReplyRender";
import ButtonRender from "./ButtonRender";
export default {
  props: ["message"],
  components: { CarouselRender, ImageRender, QuickReplyRender, ButtonRender },
  data() {
    return {};
  },
  computed: {
    isCarousel: function() {
      return !!(
        this.message.message &&
        this.message.message.message &&
        this.message.message.message.attachment &&
        this.message.message.message.attachment.payload &&
        this.message.message.message.attachment.payload.template_type ==
          "generic"
      );
    },
    isImage: function() {
      return !!(
        this.message.message &&
        this.message.message.message &&
        this.message.message.message.attachment &&
        this.message.message.message.attachment.type == "image"
      );
    },
    isQuickReply: function() {
      return !!(
        this.message.message &&
        this.message.message.messaging_type == "RESPONSE"
      );
    },
    isButton: function() {
      return !!(
        this.message.message &&
        this.message.message.message &&
        this.message.message.message.attachment &&
        this.message.message.message.attachment.payload &&
        this.message.message.message.attachment.payload.template_type ==
          "button"
      );
    },
    isBotText: function() {
      return !!(
        this.message.message &&
        this.message.message.message.text &&
        this.message.message.messaging_type != "RESPONSE"
      );
    },
    isAgentText: function() {
      return this.message.type == null && !this.message.message;
    }
  },
  mounted() {}
};
</script>
